import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../data/faqs";
import { SectionHeading, Reveal } from "./Reveal";

export function FAQAccordion({ items = FAQS, testidPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-edge border border-edge bg-slate2">
      {items.map((f, i) => (
        <div key={i}>
          <button
            data-testid={`${testidPrefix}-question-${i}`}
            aria-expanded={open === i}
            onClick={() => setOpen(open === i ? -1 : i)}
            className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-elevated/60"
          >
            <span className="font-display text-lg font-bold uppercase tracking-tight text-slate-100 sm:text-xl">
              {f.q}
            </span>
            <ChevronDown
              className={`h-5 w-5 shrink-0 text-amber2 transition-transform duration-300 ${
                open === i ? "rotate-180" : ""
              }`}
            />
          </button>
          <div
            className={`grid transition-all duration-300 ${
              open === i ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
            }`}
          >
            <div className="overflow-hidden">
              <p data-testid={`${testidPrefix}-answer-${i}`} className="px-5 pb-5 text-sm leading-relaxed text-slate-400">
                {f.a}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function FAQSection({ items, eyebrow = "Brake Questions, Answered", title = "Frequently Asked Questions" }) {
  return (
    <section data-testid="faq-section" className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-24">
      <SectionHeading eyebrow={eyebrow} title={title} />
      <Reveal className="mt-10">
        <FAQAccordion items={items} />
      </Reveal>
    </section>
  );
}
